import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import * as toastr from 'toastr';
import {UserModel} from '../../models/UserModel';
import {BaseGeneralComponent} from '../../app/BaseGeneralComponent';
import { ServiceChangesService } from 'src/app/service-changes/service/service-changes.service';

@Injectable()
export class RoleGuard extends BaseGeneralComponent implements CanActivate {

  user: UserModel;
  providerCod: string = "";
  providerDefaultSelected: any = null;
  constructor(public auth: AuthService, public router: Router) {
    super();
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.providerDefaultSelected = JSON.parse(sessionStorage.getItem("providerDefaultSelected"));
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const routeUrl = route.routeConfig.path;
    let listRole = [];

    listRole = this.filterMenuByRoleAndProvider(this.providerDefaultSelected.cod);

    if (!this.auth.isAuthenticated()) {
      if (routeUrl !== '' && routeUrl !== 'login') {
        console.error('Login before access');
      }

      if (routeUrl !== 'login') {
        this.router.navigate(['login']);
      } else {
        return true;
      }
    }

    if (routeUrl === 'login') {
      this.router.navigate(['contractual-data']);
    }

    if (!this.auth.isPageAvailable()) {
      toastr.warning('Unauthorized', '403');
      this.router.navigate(['login']);
      return false;
    }

    if(!(routeUrl.includes('new') || routeUrl.includes('edit'))) {
      let returnClause = false;
      for (var i = 0; i < listRole.length; i++) {
        if(listRole[i].link.includes(routeUrl)) {
          returnClause = true;
          break;
        } else {
          returnClause = false;
        }
      }

      if (!returnClause) {
        toastr.warning('Unauthorized', '403');
        this.router.navigate(['login']);

        return returnClause;
      }
    }


    return true;
  }
}

